// V 1.2
window.addEventListener('load', function() {
  const HCACMAP = new Map();
  window.getHCAccordion = el => HCACMAP.get(el);
  
  class Accordion {
    constructor(element, trigger, content, speed = 0.7, maxTransitionTime = 2) {
      this.el = element;
      this.el.querySelector(trigger).addEventListener('click', e => this.trigger(e));
      this.el.style.overflow = 'hidden';
      this.selectors = {trigger, content};
      this.opened = this.el.hasAttribute('opened');
      this.maxTransitionTime = maxTransitionTime;
      this.speed = speed;
      
      window.addEventListener('resize', () => this.opened = this.opened);
      
      HCACMAP.set(this.el, this);
      
      this.el.classList.add('loaded');
    }

    get triggerEl() {
      return this._trigger || (this._trigger = this.el.querySelector(this.selectors.trigger));
    }

    get contentEl() {
      return this._content || (this._content = this.el.querySelector(this.selectors.content));
    }

    set opened(val) {
      let duration = (this.contentEl.offsetHeight / 100 * this.speed);
      if (duration > this.maxTransitionTime) duration = this.maxTransitionTime;
      this.el.style.transitionDuration = duration + 's';
      
      this._opened = val;
      if (val) {
        this.el.style.height = this.triggerEl.offsetHeight + this.contentEl.offsetHeight + 'px';
        setTimeout(() => (this._opened) && (this.el.style.height = 'auto'), duration * 1000)
      } else {
        this.el.style.height = this.triggerEl.offsetHeight + this.contentEl.offsetHeight + 'px';
        setTimeout(() => (!this._opened) && (this.el.style.height = this.triggerEl.offsetHeight + 'px'));
      }
      this.el.classList.toggle('hc--opened', val);
      this.el.dispatchEvent(new CustomEvent(val ? 'hc:open' : 'hc:close'));
    }

    get opened () {
      return this._opened;
    }
    trigger() {
      this.opened = !this.opened;
    }
  }
  const initAccordion = el => {
    let speed, maxT;
    if (el.dataset.speed) speed = parseFloat(el.dataset.speed);
    if (el.dataset.maxTransisionTime) maxT = parseFloat(el.dataset.maxTransisionTime);
    new Accordion(el, '[hc-accordion-header]', '[hc-accordion-content]', speed, maxT);
  };
  document.querySelectorAll('[hc-accordion-tab]').forEach(el => {
    initAccordion(el);
  });
  const observer = new MutationObserver((mutationsList, observer) => {
    const selector = '[hc-accordion-tab]';
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node instanceof Element) {
            if (node.matches(selector)) {
            	initAccordion(node);
            } else if (node.querySelector(selector)) {
              node.querySelectorAll(selector).forEach(el => initAccordion(el));
            }
          }
        });
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});